<div class="app-page">

  @if (this.isLoading()) {
    <mat-progress-bar mode="query"></mat-progress-bar>
  }

  <div class="calendar" id="calendar">
    <ul class="weekdays">
      <li>{{ 'WEEKDAYS.MONDAY_SHORT' | translate}}</li>
      <li>{{ 'WEEKDAYS.TUESDAY_SHORT' | translate}}</li>
      <li>{{ 'WEEKDAYS.WEDNESDAY_SHORT' | translate}}</li>
      <li>{{ 'WEEKDAYS.THURSDAY_SHORT' | translate}} </li>
      <li>{{ 'WEEKDAYS.FRIDAY_SHORT' | translate}}</li>
      <li>{{ 'WEEKDAYS.SATURDAY_SHORT' | translate}}</li>
      <li>{{ 'WEEKDAYS.SUNDAY_SHORT' | translate}}</li>
    </ul>
    <ul>

      @for (day of this.Days(); track day.toDateString(); let i = $index) {
        <li [ngClass]="DayClass()[i]" id="day_{{i}}" style="height: 100px;" (click)="loadEvents(day, i)" >
          <div style="float: left;">{{day.getDate()}}</div>
          <div style="float: right; height:20px; " >
            <!-- <a href="#"
            onclick="javascript:showAddPopup('2019-11-12');"
            style="text-decoration: none; font-size: large;"><img style="height: 20px;"
          src="/img/AddCalenderitem.png"></a> -->
          </div><br>
          @for (evt of getEvents(day); track evt.EventId) {
            @if (evt.EventType==='GAME') {
              <div class="show-info-new" id="showinfo" [style.border-left]="'5px solid'+ evt.EventColor" >            
                <div style="display: flex; flex-direction: row; width: 100%;">
                  <div (click)="openGameDetails(evt)" style="flex-shrink: 3 ; min-width: 0; overflow: hidden;" >
                    {{evt.DivisionName}}<br/>
                    {{evt.HomeTeamName}}-{{evt.AwayTeamName}}<br>
                    <span style="font-weight:normal;z-index: 0;">{{evt.LastName}},{{evt.FirstName}}</span>
                  </div>
                  @if (evt.IsMyEvent) {
                    <div   [attr.eventid]="evt.EventId" (click)="deleteEventFromCalendar(evt.EventId)" >
                      <!-- <a href="#" *ngIf="evt.IsMyEvent" class="removefromschedule"
                      [attr.eventid]="evt.EventId" eventtype="GAME" [attr.divisionname]="evt.DivisionName"
                      [attr.gamename]="evt.HomeTeamName"
                      [attr.eventdate]="day"> -->
                      <!--         <img src="../assets/img/Blackcross.png" style="height: 16px;"> -->
                      <mat-icon STYLE="z-index: 100;"  aria-hidden="false" aria-label="Example home icon" style="color: black;">delete</mat-icon>
                    <!-- </a>  -->
                  </div>
                }
              </div>
              </div>
              <div class="small-dot" [style.backgroundColor]="evt.EventColor" ></div>
            }
            @if (evt.EventType==='EVENT') {
             <!--  <app-generic-event [Event]="evt" (deleteEvent)="deleteEventFromCalendar(evt.EventId)"></app-generic-event> -->
              <div class="show-info-new" id="showinfo" [style.border-left]="'5px solid'+ evt.EventColor" style="text-shadow: none; float: none; font-family: verdana; font-weight:normal;  white-space: nowrap; overflow-x:hidden;">
        <!--         @if (evt.IsMyEvent) {
                  <div style="float:right;z-index: 100;"  (click)="deleteEventFromCalendar(evt.EventId)">
                  <img *ngIf="evt.IsMyEvent" src="../assets/img/Blackcross.png" style="height: 16px;" /> 
                  <mat-icon aria-hidden="false" aria-label="Example home icon">delete</mat-icon>
                  </div> 
                
                } -->
                <div>{{evt.Title}}<br>
                  <span style="font-weight:normal;">{{evt.LastName}},{{evt.FirstName}}</span>
                </div>            
              </div>
              <div class="small-square" [style.backgroundColor]="evt.EventColor" ></div>
            }
          }
        </li>
    }

</ul>
</div>


<div>
  <div style="text-align: center; font-weight: bold; font-size: 20px;  ">
       
    {{selectedDate() | date: 'yyyy-MM-dd'}} 
   <!--  <button matButton="tonal" (click)="addGameEventToCalendar(selectedDate())" style="margin-left: 10px; margin-top: 3px; margin-bottom: 3px;"><mat-icon>add</mat-icon> {{'GENERAL.GAME' | translate | uppercase}}</button>
    <button matButton="tonal" (click)="addGenericEventToCalendar(selectedDate())" style="margin-left: 10px;"><mat-icon>add</mat-icon>{{'SCHEDULE.EVENT' | translate | uppercase}} </button>
    -->    
    <button matMiniFab [matMenuTriggerFor]="menu" style="margin-left: 10px; margin-top: 10px;">
        <mat-icon>add</mat-icon>
     </button>
      <mat-menu #menu="matMenu" yPosition="above"  xPosition="after"> 
        <button mat-menu-item (click)="addGameEventToCalendar(selectedDate())">
          <mat-icon>sports_hockey</mat-icon>
          <span>{{'GENERAL.GAME' | translate | uppercase}}</span>
        </button>
        <button mat-menu-item (click)="addGenericEventToCalendar(selectedDate())">
          <mat-icon>today</mat-icon>
          <span>{{'SCHEDULE.EVENT' | translate | uppercase}}</span>
        </button>
        
      </mat-menu>
  </div>

  <div class="selected-events-list">
          @for(evt of this.selectedDayEventlist(); track evt.EventId){
            @if (evt.EventType==='GAME') {
              <div class="show-info-new-full" id="showinfo" [style.border-left]="'5px solid'+ evt.EventColor" style="display: block;">            
                <div style="display: flex; flex-direction: row; width: 100%;">
                  <div (click)="openGameDetails(evt)" style="flex-shrink: 3 ; min-width: 0; overflow: hidden;" >
                    {{evt.EventStartUTC | date: 'HH:mm'}} {{evt.DivisionName}}<br/>
                    {{evt.HomeTeamName}}-{{evt.AwayTeamName}}<br>
                    <span style="font-weight:normal;z-index: 0; color: gray;">{{evt.LastName}},{{evt.FirstName}}</span>
                  </div>
                  @if (evt.IsMyEvent) {
                   
                    <div  style="margin-left: auto; z-index: 100;"    [attr.eventid]="evt.EventId" (click)="deleteEventFromCalendar(evt.EventId)" >
                      <!-- <a href="#" *ngIf="evt.IsMyEvent" class="removefromschedule"
                      [attr.eventid]="evt.EventId" eventtype="GAME" [attr.divisionname]="evt.DivisionName"
                      [attr.gamename]="evt.HomeTeamName"
                      [attr.eventdate]="day"> -->
                      <!--         <img src="../assets/img/Blackcross.png" style="height: 16px;"> -->
                      <mat-icon STYLE="z-index: 100;"  aria-hidden="false" >delete</mat-icon>
                    <!-- </a>  -->
                  </div>
                }
              </div>
              </div>
              
            }
            @if (evt.EventType==='EVENT') {
               <app-generic-event [Event]="evt" (deleteEvent)="deleteEventFromCalendar(evt.EventId)"></app-generic-event>
             <!--  <div class="show-info-new-full" id="showinfo" [style.border-left]="'5px solid ' + evt.EventColor" style="text-shadow: none; float: none; font-family: verdana; font-weight:normal;  white-space: nowrap; overflow-x:hidden;display: block; margin-bottom: 5px;">
                @if (evt.IsMyEvent) {
                  <div style="float:right;z-index: 100;"  (click)="deleteEventFromCalendar(evt.EventId)">
                  <!-- <img *ngIf="evt.IsMyEvent" src="../assets/img/Blackcross.png" style="height: 16px;" /> -
                    <mat-icon aria-hidden="false" aria-label="Example home icon">delete</mat-icon>
                  </div>
                
                }
                <div>{{evt.EventStartUTC +'Z' | date: 'HH:mm'}} {{evt.Title}}<br>
                  <span style="font-weight:normal; ">{{evt.LastName}},{{evt.FirstName}}</span>
                </div>            
              </div> -->
             
            }
          }@empty {
            <div style="text-align: center; font-size: 20px;color: gray;">
              {{'SCHEDULE.NOEVENTS' | translate}}
            </div>
          }
  </div>
  
<!--   @for(evt of this.selectedDayEventlist; track evt.EventId){
    <div>TEST</div>
  } -->
</div>

</div>

